import { FormService } from './FormService';

export class CustomerComplaintService extends FormService {
    constructor() {
        super("CustomerComplaints");
    }
}